<script setup lang="ts">
import { ref, reactive, onMounted, onUnmounted, computed, onBeforeMount, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from 'axios'
import AxiosUserService from "../utils/axiosUserService";
import { useUserStore } from "../store/userStore";
import { useActivityStore } from '../store/activityStore';
import { useLanguage, resolveUiLocale } from "../utils/useLanguage";
import { isLogin, checkLoginStatus, markLoggedOut } from "../utils/useAuth";

let Site_language = ref("English")

const { t, locale } = useLanguage();

const selectedCode = ref('en')

const activityStore = useActivityStore();

const axiosUserService = new AxiosUserService();

const saveProfile = axios.create({
  withCredentials: true,
})

const SwitchLangModal = ref(false)

function openSwitchLangModal() {
      SwitchLangModal.value = !SwitchLangModal.value
}

const inputValid = reactive({
  resent: false,
  email: false,
  password: false,
  emailError: "",
  pwdError: "Password is incorrect.",
  type: 'alert',
  status: false,
  title: 'Chat!',
  content: 'To send a message to other members, please first Sign up or Login!',
  msg: 'chatnow'
})

const router= useRouter();
const route= useRoute();
const path = route.path
const isVideo = computed(() => route.path === '/video');

const logout = () => {
  const axiosJsonToken = axios.create({
    withCredentials: true,
  })
  localStorage.removeItem("token")
  axiosJsonToken.post("/api/v1/user/logout").then(function (res) {
    markLoggedOut()
    router.push("/admin/login");
          
  }).catch(function (res) {

    console.log('logout error',res)
    //router.push("/admin/login");

  })

}

function UserDropdown(target: string) {
  const targetDropdown: HTMLDivElement = document.getElementById(target) as HTMLDivElement;
  targetDropdown.classList.toggle("active");

  document.addEventListener('mouseup', (event: Event) => { 
    if (!targetDropdown.contains(event.target as Node)) {
      targetDropdown.classList.remove("active");
    }
  }, { once: true });
}

function menuShow() {
  const mobileMenu: HTMLDivElement = document.querySelector(".mobileMenu") as HTMLDivElement;
  mobileMenu.classList.add('open');

  const handleClickOutside = (event: MouseEvent) => {
    if (!mobileMenu.contains(event.target as Node)) {
      mobileMenu.classList.remove("open");
        document.removeEventListener('mouseup', handleClickOutside);
    }
  };

  document.addEventListener('mouseup', handleClickOutside);

}

let showModal = ref<boolean>(false);
const userMsg: any = ref({})
const proclaim = ref(true)
function closeProclaim(){
  localStorage.setItem("proclaim", 'false');
  proclaim.value = false
}

const extractUsername = (email:any, nickName:any) => {
  // Check if nickName is empty
  if (!nickName) {
    // Split the email address at the "@" symbol
    const parts = email.split("@");
    const username = parts[0];
    return username;
  } else {
      return nickName;
  }
}

const userStore = useUserStore();

/**
 * 介面語言規則：
 * - Admin 或 @mimir.com 帳號：依 siteLanguage 切換介面
 * - 其他帳號：一律使用英文介面
 *
 * siteLanguage 是使用者母語（字典查詢的 to_language），不受此規則影響。
 */
function applySiteLanguage() {
  const siteLanguage =
    userStore.site_language ||
    localStorage.getItem('siteLanguage') ||
    'English';

  Site_language.value = siteLanguage;
  selectedCode.value = resolveUiLocale(siteLanguage);
  locale.value = selectedCode.value;
}



function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
  let timeout: number | undefined;
  return (...args: Parameters<T>) => {
    if (timeout) window.clearTimeout(timeout);
    timeout = window.setTimeout(() => func(...args), wait);
  };
}

const handleScroll = debounce(() => {
  const scroll = window.pageYOffset;
  const subMenu = document.querySelector(".subMenu") as HTMLDivElement | null;

  // ✅ 跳頁後可能不存在，直接退出，避免 classList error
  if (!subMenu) return;

  if (scroll > 50) {
    subMenu.classList.add("sticky");
    document.body.classList.add("header-padding");
  } else {
    subMenu.classList.remove("sticky");
    document.body.classList.remove("header-padding");
  }

  if (scroll > 150) subMenu.classList.add("animation");
  else subMenu.classList.remove("animation");
}, 100);




function changeLL(lang: string) {
  let nextSiteLanguage: string;

  if (
    userStore.user_role === 'Admin' &&
    userStore.site_language === 'Simplified_Chinese'
  ) {
    nextSiteLanguage = 'Simplified_Chinese';
  } else {
    nextSiteLanguage =
      lang === 'English'
        ? 'Spanish'
        : 'English';
  }

  const patchList = {
    nick_name: userStore.nick_name,
    learning_language: lang,
    site_language: nextSiteLanguage,
  };

  saveProfile
    .patch('/api/v1/user/me', patchList)
    .then((res) => {
      learning_language.value = res.data.learning_language;
      Site_language.value =
        res.data.site_language || nextSiteLanguage;

      localStorage.setItem(
        'learningLanguage',
        res.data.learning_language
      );

      localStorage.setItem(
        'siteLanguage',
        res.data.site_language || nextSiteLanguage
      );

      userStore.setLanguages(
        res.data.learning_language,
        res.data.site_language || nextSiteLanguage
      );

      applySiteLanguage();
      openSwitchLangModal();
    })
    .catch((response) => {
      console.log('save error', response);
    });
}

const resend = () => {
 
  axiosUserService.requestEmailVerify(userMsg.value.email)
  .then(function(res){
    inputValid.resent = true
    // console.log('resend',res)
  })
  .catch(function(res){
    inputValid.resent = false
    console.log('resend error',res)

  })

}

const learning_language = ref(localStorage.getItem("learningLanguage") || "Simplified_Chinese")
watch(learning_language, (newVal) => {
  console.log("Language changed:", newVal)
  localStorage.setItem("learningLanguage", newVal)
})

watch(() => userStore?.is_verified, (newVal) => {
  if (!newVal && isLogin.value) {
    console.log("User is not verified");
  }
});

// ✅ 若 userStore.user_role 是非同步才拿到，補一個 watch 讓語言規則能即時套用
watch(
  [
    () => userStore.user_role,
    () => userStore.email,
    () => userStore.site_language,
  ],
  () => {
    applySiteLanguage();
  }
);

const kickstartTo = computed(() => {
  if (learning_language.value === 'Spanish') return '/kickstart-sp'
  if (learning_language.value === 'English') return '/kickstart-en'
  return '/kickstart'
})


onBeforeMount(async() => {
  checkLoginStatus();
  
  const route= useRoute();
  const authToken = route.query.accessToken as string | undefined

  if (authToken !== undefined && authToken != null) {
    localStorage.setItem("token", authToken);

    const redirect = sessionStorage.getItem("google_login_redirect");
    sessionStorage.removeItem("google_login_redirect");

    if (redirect) {
      if (redirect.startsWith("http")) {
        window.location.href = redirect;
      } else {
        router.push(redirect);
      }
    } else {
      router.push("/platform");
    }
  } else {
      console.log("no authToken")
    }



  if (!localStorage.getItem("proclaim")) {
    localStorage.setItem("proclaim", "true");
  }
  proclaim.value = JSON.parse(localStorage.getItem("proclaim") || "true");
})
onMounted(async() => {
  window.addEventListener("scroll", handleScroll, { capture: true });
  console.log("Mounted, learning language:", learning_language.value);
  activityStore.logTimeOfDayActivity();

  // ✅ 只在這裡統一套用介面語言規則
  //    非 Admin 強制英文；Admin 才依 siteLanguage 切換
  applySiteLanguage();

  const irclickid = route.query.irclickid as string | undefined
})
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll, { capture: true } as any);
});


</script>
<template >
      <header :class="['subMenu', isVideo ? 'isvideo' : '']">
        <p class="bg-sd white-1 i-flex a-center j-center t-center wrap gap-5 font-2 lh-15 sticky prompt" ><img class="s-15" src="/icon-alert.png">  {{ t('Please confirm your email to fully activate your account. You can do this by clicking the link in the email confirmation we sent you.')}}<span @click="resend" class="link white-1 bold" :class="inputValid.resent? 'alert':''">{{ !inputValid.resent? 'Resend Email': 'Resent!'}}</span></p>
        <p class="bg-black-5 black-3 t-center p-5 lh-15 sticky" v-if="proclaim"> 
          <img class="img mr-5" src="/English.png" alt="USA icon" style="width: 15px">
          <span class="fs-075r" style="vertical-align: text-bottom;">

            {{ t('The Mimir is operated by Contemporary Education and Technology Inc., a corporation registered in the state of California, USA.') }}

          </span>
          <span class="icon-close sm black-3 pointer abs" style="right: 10px; top: 10px;" @click="closeProclaim()"></span>
        </p>
    
        <div id="navbar" class="rel" :class="[isLogin ? 'log-in': 'log-out' ,'container flex j-between a-center']">
            <nav class="flex a-center gap-20 md-none ">
                <a href="/" class="md-none">
                    <img class="logo ontop" src="/logo_2024.png" alt="">
                    <img class="logo scrollin" src="/logo_2024_black.png" alt="">
                </a>
                <a href="/" class="md-block">
                    <img class="logo" src="/logo-icon.png" alt="">
                </a>
                <a class="link_nav" href="https://lab.themimir.com/index.html">{{ t('Curriculum') }}</a>
                <router-link class="link_nav" :to="kickstartTo">{{ t('Kickstart') }}</router-link>
                <router-link class="link_nav" to="/video">{{ t('Watch') }}</router-link>
                <router-link class="link_nav" to="/read">{{ t('Read') }}</router-link>
                <router-link class="link_nav" to="/speak">{{ t('Speak') }}</router-link>
                <router-link class="link_nav" to="/blog">{{ t('Blog') }}</router-link>

            </nav>

            <nav class="nav i-flex a-center gap-10 " >
              <div class="flex a-center gap-10 pad-none" v-if="isLogin == true">
                    <!-- Event Alert -->
                    <!-- <div
                      id="event"
                      class="link-nav rel"
                      @click="EventDropdown('event')"
                      v-if="allcoming?.value?.length > 0"
                      >
                      <span class="icon-speak circle pointer"></span>

                      <nav
                        class="dropdown flex column bg-white-1 abs"
                        v-show="showEventDropdown"
                      >
                        <router-link
                          target="_blank"
                          :to="{ name: 'SpeakDetail', params: { id: item.id } }"
                          class="eventItem flex a-center gap-5 p-10"
                          v-for="(item, index) in allcoming?.value || []"
                          :key="index"
                        >
                          <div class="tag sm bg-black-5 fs-075r">
                            {{ item.debate_type === 'mini_debate'
                              ? 'Mini Talk'
                              : item.debate_type === 'role_play'
                              ? 'Role Play'
                              : 'Debate' }}
                          </div>
                          <h3 class="fs-075r">{{ item.title_cn }}</h3>
                        </router-link>
                      </nav>

                      <div class="eventAlert i-flex j-center a-center br-10 white-1 abs">
                        {{ allcoming?.value?.length }}
                      </div>
                    </div>
            -->
                    <!-- User Dropdown -->
                    <div id="account" class="link-nav rel" @click="UserDropdown('account')" >
                        <img 
                          class="avatar-xs pointer md-none" 
                          :src="userStore?.avatar_file_id ? `/api/v1/user/avatar/storage/${userStore?.avatar_file_id}` : '/avatar-default.png'" 
                          alt=""
                        >
                        <span class="unreadBadge tag bg-pr white-1 abs md-none" v-if="userStore.unread_notifications > 0">{{ userStore.unread_notifications }}</span>
                        <nav class="dropdown flex column gap-10 bg-white-1 abs p-20">
                            <div class="flex a-center j-between gap-10">
                                <div>
                                    <h4 class="title-2 fw-semiBold">{{ extractUsername(userStore?.email, userStore?.nick_name) }}</h4>
                                    <p class="instruction ">{{ userStore?.email }}</p>
                                </div>
                                <span class="tag" :class="[userStore?.user_role !== 'Mentor' ? 'bg-sd' : 'bg-pr', 'white-1']">{{ t(userStore?.user_role) }}</span>
                            </div>
                            <hr class="hr-line">
                            <!-- <div>

                              <div class="fw-bold fs-075r"> {{ t('Learning Language') }}</div>
                              <div class="flex a-center gap-20 mt-5">

                                <div class="tag bg-white-3">
                                
                                  <img
                                    :src="learning_language === 'Spanish'
                                      ? '/Spanish_big.png'
                                      : learning_language === 'English'
                                      ? '/English_big.png'
                                      : '/Chinese_big.png'"
                                    alt="Learning Language"
                                    class="s-20"
                                  />
                                  {{ t(learning_language || 'Simplified_Chinese') }}
                                </div>
                              </div>
                            </div> -->

                            <div class="fw-bold fs-075r"> {{ t('Dashboard') }}</div>

                            <router-link class="flex gap-10" to="/user/center"><span class="icon-dashboard md"></span>{{ t('Learning Center') }}</router-link>
                            <router-link class="flex gap-10" to="/teacher/profile" v-if="userStore?.user_role !== 'Member'"><span class="icon-library md"></span>{{ t('Teacher Center') }}</router-link>
                            <router-link class="flex gap-10" to="/user/notification"><span class="icon-alert md"></span> {{ t('Notification') }} <span class="tag bg-pr white-1" v-if="userStore.unread_notifications > 0">{{ userStore.unread_notifications }}</span></router-link>
                            <router-link class="flex gap-10" to="/user/vocabulary/notebook"><span class="icon-book md"></span> {{ t('Notebook') }}</router-link>
                            <router-link class="flex gap-10" to="/setting" ><span class="icon-setting md"></span>{{ t('Account Setting') }}</router-link>
                            <router-link class="flex gap-10" to="/cms" v-if="userStore?.user_role == 'Admin'"><span class="icon-fixed-filled md"></span>{{ t('Administration') }}</router-link>
                            <hr class="hr-line">
                            
                            <div class="pointer flex gap-10" @click="logout"><span class="icon-logout md"></span>{{ t('Logout') }}</div>
                        </nav>
                    </div>
                    
                

                    <router-link to="/subscribe" class="btn capsule bg-sd white-1" v-if="!path.includes('/subscribe') && !userMsg.stripe_subscribed && !userStore.is_paid">
                      {{ t('Subscribe') }}
                    </router-link>
                   
                    <span class="icon-ham pointer md" id="menuOpen" @click="menuShow" v-if="path.includes('/subscribe')"></span>
                </div>
                <div class="flex a-center gap-10 pad-none" v-else>
                    <router-link to="/admin/login" class="btn capsule outline br-sd sd">
                      {{ t('Login') }}
                    </router-link>
                    <router-link to="/subscribe" class="btn capsule bg-sd white-1">
                      {{ t('Subscribe') }}
                    </router-link>
       
                </div>
          
           
                <span class="menu icon-ham md pad-block black-1 pointer" id="menuOpen" @click="menuShow" ></span>
                <!-- Site Language -->
                <!-- <div id="siteLanguage" class="link-nav rel" @click="UserDropdown('siteLanguage')" v-if="userStore?.user_role == 'Admin'">
                    <div class="flex a-center gap-5">
                      <span class="icon-earth "></span>{{ t(selectedCode) }}
    
                    </div>
          
                  </div> -->
                  <div   v-if="isLogin" id="learningLanguage" class="link-nav rel" @click="UserDropdown('learningLanguage')">
                      <div class="flex a-center gap-5">
                        
                        <img :src="learning_language === 'Spanish' ? '/Spanish_big.png' : learning_language === 'English' ? '/English_big.png' : '/Chinese_big.png'" alt="Learning Language" class="s-20"/>
                        <nav class="dropdown flex column gap-10 bg-white-1 abs p-20">
                            <div class="fw-bold fs-075r"> {{ t('Learning Language') }}</div>
                              <div class="flex column-sm a-center j-between gap-10">
                                <div class="btn sm " :class="learning_language === 'Simplified_Chinese' ? 'bg-pr' : 'bg-white-4 black-1'" @click="changeLL('Simplified_Chinese')">{{ t('Chinese') }}</div>
                                <div class="btn sm " :class="learning_language === 'Spanish' ? 'bg-pr' : 'bg-white-4 black-1'" @click="changeLL('Spanish')">{{ t('Spanish') }}</div>
                                <div class="btn sm " :class="learning_language === 'English' ? 'bg-pr' : 'bg-white-4 black-1'" @click="changeLL('English')">{{ t('English') }}</div>
                              </div>
                          </nav>
                      </div>
          
                  </div>
              </nav> 
        </div>
    </header>

    <!-- mobileMenu -->
    <div class="mobileMenu rel pd-40 ">
        <div class="container flex column gap-10">
            <a href="/"><img class="logo-sm" src="/logo_2024_black.png" alt=""></a>
        
            <nav class="flex column gap-10 mt-10" v-if="isLogin">
                  <div class="flex a-center gap-5 mb-5">
                    <p class="font-4">{{ userMsg.email }} </p>
                    <span class="tag bg-dark-200 white-1">{{ t(userStore?.user_role) }}</span>
                  </div>

                  <div class="flex a-center gap-10">
                    <div class="fw-bold fs-075r"> {{ t('Learning Language') }}</div>
                    <div class="flex a-center gap-20">
  
                      <div class="tag bg-white-3">
                          <img :src="learning_language === 'Spanish' ? '/Spanish_big.png' : learning_language === 'English' ? '/English_big.png' : '/Chinese_big.png'" alt="Learning Language" class="s-20"/>
                        {{ t(learning_language || 'Simplified_Chinese') }}
                      </div>
                    </div>
                  </div>
                <hr class="hr-line">
                <div class="fw-bold fs-075r"> {{ t('Service') }}</div>
                <a class="flex gap-10" href="https://lab.themimir.com/index.html"><span class="icon-lesson md"></span>{{ t('Curriculum') }}</a>

                <router-link class="flex gap-10" :to="kickstartTo"><span class="icon-rocket md"></span>{{ t('Kickstart') }}</router-link>
                <router-link class="flex gap-10 " to="/video"><span class="icon-watch md"></span>{{ t('Watch') }}</router-link>
                <router-link class="flex gap-10 " to="/read"><span class="icon-read md"></span>{{ t('Read') }}</router-link>
                <router-link class="flex gap-10 " to="/speak"><span class="icon-speak md"></span>{{ t('Speak') }}</router-link>
                <router-link class="flex gap-10 " to="/blog"><span class="icon-files md"></span>{{ t('Blog') }}</router-link>
                <hr class="hr-line">
                <div class="fw-bold fs-075r"> {{ t('Dashboard') }}</div>
                <router-link class="flex gap-10 " to="/user/center"><span class="icon-dashboard md"></span>{{ t('Learning Center') }}</router-link>
                <router-link class="flex gap-10" to="/user/notification"><span class="icon-alert md"></span> {{ t('Notification') }} <span class="tag bg-pr white-1" v-if="userStore.unread_notifications > 0">{{ userStore.unread_notifications }}</span></router-link>
                <router-link class="flex gap-10" to="/user/vocabulary/notebook"><span class="icon-book md"></span> {{ t('Notebook') }}</router-link>
                <router-link class="flex gap-10" to="/user/activities"><span class="icon-timer md"></span> {{ t('Activities') }}</router-link>
                <router-link class="flex gap-10 " to="/subscribe"><span class="icon-bag md"></span>{{ t('Subscribe') }}</router-link>
                <hr class="hr-line">
                <div class="fw-bold fs-075r"> {{ t('Setting') }}</div>

                <router-link class="flex gap-10" to="/setting"><span class="icon-setting md"></span>{{ t('Account Setting') }}</router-link>
                <router-link class="flex gap-10" to="/cms" v-if="userMsg.user_role == 'Admin'"><span class="icon-fixed-filled md"></span>{{ t('Administration') }}</router-link>
                <div class="pointer flex gap-10" @click="logout"><span class="icon-logout md"></span> {{ t('Logout') }}</div>
            </nav>
            <nav class="t-center mt-20" v-else>
                <nav class="flex column gap-10 mb-20">
                    <a class="flex gap-10" href="https://lab.themimir.com/index.html"><span class="icon-lesson md"></span>{{ t('Curriculum') }}</a>
                    <router-link class="flex gap-10" :to="kickstartTo"><span class="icon-rocket md"></span>{{ t('Kickstart') }}</router-link>
                    <router-link class="flex gap-10 " to="/video"><span class="icon-watch md"></span>{{ t('Watch') }}</router-link>
                    <router-link class="flex gap-10 " to="/read"><span class="icon-read md"></span>{{ t('Read') }}</router-link>
                    <router-link class="flex gap-10 " to="/speak"><span class="icon-speak md"></span>{{ t('Speak') }}</router-link>
                    <router-link class="flex gap-10 " to="/blog"><span class="icon-files md"></span>{{ t('Blog') }}</router-link>

                   
                </nav>

                <div class="flex gap-10 j-center column-sm">
                  <router-link to="/admin/login" class="btn capsule bg-pr white-1">
                    {{ t('Login') }}

                  </router-link>
                  <router-link to="/subscribe" class="btn capsule bg-sd white-1">
                    {{ t('Subscribe') }}
                  </router-link>

                </div>

                <!-- <p class="sans-serif mb-20 mt-20 ">Don’t have an account? <br> <router-link class="pr"
                        to="/admin/register">Sign up</router-link> Now!</p> -->
            </nav>
        </div>
    </div>
    <!-- Modal if user not verify-->
    <div class="modal fixed p-center" :class="{active: showModal === true}">
      <div class="modalTitle title-1 flex j-between bg-dark white-1">Please Verify Your Email</div>
      <div class="modalContent bg-white-1 scroll">
        <div class="flex solumn-sm column a-center gap-20 p-40">
          <img class="s-30" src="/icon-alert.svg" alt="">
          <p class="dark title-2 bold">Please confirm your email to fully activate your account. You can do this by clicking the link in the email confirmation we sent you. </p>
        </div>
      </div>
      <div class="modalFooter bg-white-1">
        <div class="t-right">
          <div class="flex gap-5 j-center">
            <button class="btn-sm bg-dark" v-if="!inputValid.resent" @click="resend">Resend Email</button>
            <div v-else class="dark title-2" >Sent!</div>
          </div>
        </div>  
      </div>
    </div>

    <div id="mask" class="mask fixed" :class="{active: showModal === true}" ></div>
    <Modal v-model:type="inputValid.type" v-model:title="inputValid.title" v-model:content="inputValid.content" v-model:status="inputValid.status"  v-model:msg="inputValid.msg"/>

    <BaseModal
        modalId="SwitchLanguage"
        v-model="SwitchLangModal"
        :title="t('lang_switched')"
        titleTheme="light"
        :showCancel="false"
        :showConfirm="true"
        :showRefresh="false"
        :showDelete="false"
        @confirm="openSwitchLangModal"
    >

    <div class="flex column-sm column a-center gap-20">
      <img  class="s-20" src="/icon-checked.png" alt="Checked Mark">
      <p>
        {{ t('lang_changed', { lang: t(learning_language === 'Spanish' ? 'Spanish' : learning_language == 'English' ? 'English' :  'Mandarin Chinese') }) }}

      </p>
    </div>
    </BaseModal>
</template>

<style scoped>
/* @import '../assets/css_lib/themimir.css'; */

.unreadBadge {
  top: -4px;
  right: -8px;
  padding: 0 6px;
  font-size: 0.7rem;
  line-height: 1.4;
  pointer-events: none;
}

body.header-padding {
  padding-top: 40px;
}

/* Header  
   ===================================================*/

header{
    box-shadow: 0px 4px 4px rgba(159, 159, 159, 0.25);
    background-color: white;  
}
header > div{
    height: 75px;
}
@media all and (max-width: 960px){
  header > div{
      height: 60px;
  }

}
@media all and (max-width: 768px){
  header > div{
      height: 45px;
  }

}
.subMenu.isvideo{
  background-color: #9747ff;  
}
.subMenu.isvideo.sticky{
  background-color: white;  
}

/* white logo */
.subMenu.isvideo:not(.sticky) .logo.ontop{
    display: block;
}

/* black logo */
.subMenu:not(.isvideo) .logo.scrollin,
.subMenu.sticky .logo.scrollin{
    display: block;
}

.menu{
    font-size: 36px;
}

.link_nav{
  color: #505050;
  font-size: 20px;
  font-weight: 500;
}
.link_nav[class*="icon"]{
  font-size: 25px;
}
.subMenu.isvideo .link_nav{
  color: #fff;
}


/* sticky */
.subMenu.sticky {
    width: 100%;
    position: fixed;
    top: -75px;
    left: 0;
    z-index: 999998;
    background: #fff;
    transition: top 1s;
}

.subMenu.sticky.animation{
    top: 0rem;
}

.subMenu.sticky .link_nav{
    color: #505050;
}
.subMenu .link_nav.active{
  color: #ffb805;
}

.subMenu{
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100vw;
    /* box-shadow: 0px 0px 1px #ffffff10; */
    /* height: 75px; */
    background: #fff;
}

/* Subnav */
.nav {
    z-index: 99;
    height: 2.5rem;
}

/* mobileMenu */
.userMenu,
.mobileMenu {
    position: fixed;
    top: 0;
    width: 85vw;
    height: 100%;
    z-index: 999998;
    background: #fff;
    transition: all .3s ease-in;
    overflow: hidden;
    overflow-y: scroll;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}

.userMenu{
    width: 300px;
    right: -300px;
}
.userMenu.open{
    right: 0px;
}
.mobileMenu {
    opacity: 0;
    left: 0;
    pointer-events: none;

}
.mobileMenu.open {
    opacity: 1;
    pointer-events: all;
}

#menuClose {
    right: .625rem;
    top: .625rem;
}

.mobileMenu.log-in nav:last-child {
    display: none;
}

.mobileMenu.log-out nav:first-child {
    display: none;
}



.subMenu-fixed .brand>.logo-sm,
.sticky .brand>.logo-sm {
    top: 0;
}




/* Subnav */
.nav {
    z-index: 99;
    height: 2.5rem;
}

/*
new drop down
*/
.new-dropdown{
    background-color: #000;
}

/* Login Dropdown */

.dropdown {
    opacity: 0;
    z-index: -1;
    pointer-events: none;

    width: max-content;
    margin-top: .625rem;
    top: 100%;
    border-radius: .3125rem;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);

}

.dropdown::before {
    content: '';
    position: absolute;
    top: -1rem;
    border: .5rem solid transparent;
    border-bottom-color: #fff;
}
@media all and (min-width: 769px){
  .dropdown {
    right: 0;
  }
  .dropdown::before {
      right: .1875rem;
  }
}

@media all and (max-width: 768px){
  .dropdown {
    left: 0;
  }
  .dropdown::before {
    left: 0;
  }
}

.active .dropdown {
    pointer-events: all;

    opacity: 1;
    z-index: 99;

}

.eventItem:hover{
  background: #f2f2f2;
}
.eventAlert{
  width: 20px;
  height: 20px;
  right: -7px;
  top: -7px;
  font-size: 12px;
  background: red;
}

/* Fast Login */
.dropdown-fastlogin {
    opacity: 0;
    z-index: -1;
    pointer-events: none;

    transition: all .3s;
    width: 100vw;
    background: #E2F5FD;
    top: 2.5rem;
    left: 0;
    z-index: 99;
}

.log-out.active .dropdown-fastlogin {
    pointer-events: all;

    opacity: 1;
    z-index: 99;
}

/* promotion */
.promote {
    width: 25rem;
    height: 15.625rem;
    overflow: hidden;
    background-color: #FFED94;
    background-image: url(/subscription.png);
    background-size: 8.4375rem auto;
    background-repeat: no-repeat;
    background-position: right 2.5rem bottom 1.25rem;
    top: calc(-100% - 40px);
    right: 0;
    padding: 1.25rem;
    opacity: 0;
    pointer-events: none;
    transition: all .3s ease-in-out;

}
.promote h4{
    margin-bottom: 0.8rem;
}
.promotion:hover>.promote {
    pointer-events: all;
    top: 100%;
    opacity: 1;
    z-index: 99;
}

/* Prompt */
.prompt{
    display: none;
    padding: 10px;
    width: 100%;
    z-index: 9999;
}
.prompt.show{
    display: flex;
}

/* notification */
.notifications{
    position: absolute;
    width: 320px;
    min-height: 62px;
    height: auto;
    padding: 20px;
    top: 70px;
    box-shadow: 0 4px 4px #9f9f9f40;
    background-color: #fff!important;
    border-radius: 8px;
}

.notification-card{
    border-top:1px solid #9f9f9f40;
    min-height: 62px;
}

.notification-card:hover{
    background-color: #ebe9e9;
}
</style>